<template>
	<section>
		privacy

		<TypographyKTypographyH1
			font-type="bold"
			color="var(--black)"
			tag-type="h1"
		>
			Политика конфиденциальность
		</TypographyKTypographyH1>
	</section>
</template>

<script setup lang="ts">
	definePageMeta({
		auth: false,
		layout: 'empty'
	});
</script>

<style scoped lang="scss"></style>
